var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinhaContaSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92897 1.125H15.195C15.6724 1.125 16.1302 1.31464 16.4678 1.65221C16.8053 1.98977 16.995 2.44761 16.995 2.925V15.195C16.995 15.6724 16.8053 16.1302 16.4678 16.4678C16.1302 16.8054 15.6724 16.995 15.195 16.995H2.92897C2.45158 16.995 1.99375 16.8054 1.65618 16.4678C1.31861 16.1302 1.12897 15.6724 1.12897 15.195V2.929C1.12845 2.69228 1.17462 2.45779 1.26484 2.23894C1.35506 2.02009 1.48757 1.82119 1.65476 1.65362C1.82196 1.48605 2.02057 1.35311 2.23922 1.2624C2.45786 1.17169 2.69226 1.125 2.92897 1.125V1.125Z",
    stroke: "#000FFF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.575 1.125H36.841C37.3184 1.125 37.7762 1.31464 38.1138 1.65221C38.4513 1.98977 38.641 2.44761 38.641 2.925V15.195C38.641 15.6724 38.4513 16.1302 38.1138 16.4678C37.7762 16.8054 37.3184 16.995 36.841 16.995H24.575C24.0976 16.995 23.6397 16.8054 23.3022 16.4678C22.9646 16.1302 22.775 15.6724 22.775 15.195V2.929C22.7744 2.69228 22.8206 2.45779 22.9108 2.23894C23.0011 2.02009 23.1336 1.82119 23.3008 1.65362C23.468 1.48605 23.6666 1.35311 23.8852 1.2624C24.1039 1.17169 24.3383 1.125 24.575 1.125V1.125Z",
    stroke: "#000FFF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.92897 22.771H15.195C15.4314 22.771 15.6654 22.8176 15.8838 22.908C16.1022 22.9985 16.3006 23.1311 16.4678 23.2982C16.6349 23.4653 16.7675 23.6638 16.858 23.8822C16.9484 24.1006 16.995 24.3346 16.995 24.571V36.841C16.995 37.3184 16.8053 37.7762 16.4678 38.1138C16.1302 38.4514 15.6724 38.641 15.195 38.641H2.92897C2.45158 38.641 1.99375 38.4514 1.65618 38.1138C1.31861 37.7762 1.12897 37.3184 1.12897 36.841V24.575C1.12845 24.3383 1.17462 24.1038 1.26484 23.8849C1.35506 23.6661 1.48757 23.4672 1.65476 23.2996C1.82196 23.132 2.02057 22.9991 2.23922 22.9084C2.45786 22.8177 2.69226 22.771 2.92897 22.771V22.771Z",
    stroke: "#000FFF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.575 22.771H36.841C37.0773 22.771 37.3114 22.8176 37.5298 22.908C37.7482 22.9985 37.9466 23.1311 38.1138 23.2982C38.2809 23.4653 38.4135 23.6638 38.504 23.8822C38.5944 24.1006 38.641 24.3346 38.641 24.571V36.841C38.641 37.3184 38.4513 37.7762 38.1138 38.1138C37.7762 38.4514 37.3184 38.641 36.841 38.641H24.575C24.0976 38.641 23.6397 38.4514 23.3022 38.1138C22.9646 37.7762 22.775 37.3184 22.775 36.841V24.575C22.7744 24.3383 22.8206 24.1038 22.9108 23.8849C23.0011 23.6661 23.1336 23.4672 23.3008 23.2996C23.468 23.132 23.6666 22.9991 23.8852 22.9084C24.1039 22.8177 24.3383 22.771 24.575 22.771V22.771Z",
    stroke: "#000FFF",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.77,
    height: 39.77,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinhaContaSelected);
export default __webpack_public_path__ + "static/media/ic_minha-conta_selected.40a7096cc4010564d1dc6b38f399f94c.svg";
export { ForwardRef as ReactComponent };